
<div class="error white--text text-center ml-2" :class="size">
    Clipboard
</div>
